import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';

import './guide_box.scss';

const { BUTTON_THEMES } = Buttons.constants;

const CLASS_NAME = 'guide-box';

class GuideBox extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSkipped: false,
    };

    this.onPrimaryAction = this.onPrimaryAction.bind(this);
  }

  onPrimaryAction() {
    this.setState({ isSkipped: true });
    _.invoke(this.props, 'primaryAction');
  }

  render() {
    const {
      active,
      className,
      description,
      primaryAction,
      primaryButtonText,
      secondaryAction,
      secondaryButtonText,
      title,
    } = this.props;
    const { isSkipped } = this.state;

    const withPrimaryButton = _.isFunction(primaryAction);
    const withSecondaryButton = _.isFunction(secondaryAction);

    return (
      <div className={CLASS_NAME}>
        {active && (
          <div
            className={classnames(`${CLASS_NAME}__content`, className, {
              [`${CLASS_NAME}__content--is-active`]: active && !isSkipped,
              [`${CLASS_NAME}__content--is-skipped`]: isSkipped,
            })}
          >
            <div className={`${CLASS_NAME}__container`}>
              <div className={`${CLASS_NAME}__title`}>{title}</div>
              {!_.isEmpty(description) && (
                <div className={`${CLASS_NAME}__description`}>{description}</div>
              )}

              {(withPrimaryButton || withSecondaryButton) && (
                <div className={`${CLASS_NAME}__button-wrapper`}>
                  {withPrimaryButton && (
                    <Buttons.TextButton
                      className={`${CLASS_NAME}__button--primary`}
                      disabled={isSkipped}
                      theme={BUTTON_THEMES.PRIMARY}
                      onClick={this.onPrimaryAction}
                    >
                      {primaryButtonText}
                    </Buttons.TextButton>
                  )}
                  {withSecondaryButton && (
                    <Buttons.TextButton
                      disabled={isSkipped}
                      theme={BUTTON_THEMES.LINK_SUBTLE}
                      onClick={() => secondaryAction()}
                    >
                      {secondaryButtonText}
                    </Buttons.TextButton>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

GuideBox.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  title: PropTypes.string.isRequired,
};

GuideBox.defaultProps = {
  active: true,
  className: '',
  description: '',
  primaryButtonText: 'Got it',
  secondaryButtonText: 'Learn more',
};

export default GuideBox;
